interface EventDateBoundary {
	start: Date;
	end: Date | null;
}

export const normalizeCalendarDateToMinute = (date: Date): Date => {
	const normalizedDate = new Date(date);
	normalizedDate.setSeconds(0, 0);
	return normalizedDate;
};

export const normalizeCalendarEventDateBoundary = ({
	start,
	end,
}: EventDateBoundary): EventDateBoundary => ({
	start: normalizeCalendarDateToMinute(start),
	end: end ? normalizeCalendarDateToMinute(end) : null,
});
